import { React, useEffect, useState, } from "react";
import { useMediaQuery } from "react-responsive";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoginForm from "../components/loginForm";
import Footer from "../components/layouts/footer";
import { MainPageHead,LoadingTemplate } from "../components/helpful";
import { useDispatch } from "react-redux";
import {
  storeCountries,
  storeUserTypes,
  storeMarkets,
  storeDocCategories
} from "../store/reducer";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import {
  getCountries,
  getUserTypes,
  getMarkets,
  getLoginBg,
  getDocumentCategories
} from "../api/api";
import Background from "../assets/img/login-page-bg.jpg";
import { useTranslation } from "react-i18next";

/**
 * The Main function in this JavaScript code fetches data for background images and other necessary
 * information, sets up the page layout with conditional rendering based on device size, and displays a
 * login form with a footer.
 * @returns The `Main` component is being returned. Inside the component, there are various hooks being
 * used such as `useDispatch`, `useMediaQuery`, `useTranslation`, `useState`, and `useEffect`. The
 * component fetches data using `useQuery` for login background, countries, user types, and markets. It
 * also sets the background image based on the screen size (mobile or desktop).
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com>
 */
export default function Main() {
  
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { t } = useTranslation();
  const [pageBgImg, setBG] = useState(Background);
  const [userGroup, setUserGroup] = useState(0);
 


  const loginBg = {
    backgroundImage: `url(${pageBgImg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "100vh",
    width: "100%",
  };
  const { data, error, isLoading } = useQuery({
    queryKey: ["loginBg"],
    queryFn: getLoginBg,
    // staleTime: 1000 * 60 * 5,
    // cacheTime: 1000 * 60 * 30,
  });
  
  const countries = useQuery({
    queryKey: ["countries"], 
    queryFn: getCountries,
    // staleTime: 1000 * 60 * 5, // fetch again after 10 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes
  });
  const userTypes = useQuery({
    queryKey: ["userTypes",userGroup],
    queryFn: () => getUserTypes(userGroup),
    // staleTime: 1000 * 60 * 30,
    cacheTime: 1000 * 60 * 30,
  });

  const markets = useQuery({
    queryKey: ["markets"],
    queryFn: getMarkets, 
    // staleTime: 1000 * 60 * 30,
    cacheTime: 1000 * 60 * 30,
  });

  useEffect(() => {
    const getDocCategories = async () => {
      let categories = await getDocumentCategories('en');
      if (categories && categories.length > 0) {
        dispatch(storeDocCategories(categories));
      }
    };

    getDocCategories();
  }, [dispatch]); 

  useEffect(() => {
    if (data) {
     
      if (isMobile) {
        if(data?.mobile?.image?.imageDerivatives?.default_url){
          setBG(data.mobile.image.imageDerivatives.default_url);
        }else{
          setBG(Background);
        }
       
      } else {
        if(data?.desktop?.image?.imageDerivatives?.default_url){
          setBG(data.desktop.image.imageDerivatives.default_url);
        }else{
          setBG(Background);
        }
        
      }
    }
  }, [data, isMobile]);



  useEffect(() => {
    if (countries.data) {
      dispatch(storeCountries(countries.data));
    }
  }, [countries, dispatch]);

  useEffect(() => {
    if (userTypes.data) {
      dispatch(storeUserTypes(userTypes.data));
    }
  }, [userTypes, dispatch]);

  useEffect(() => {
    if (markets.data) {
      dispatch(storeMarkets(markets.data));
    }
  }, [markets, dispatch]);

  if (isLoading) return <div><LoadingTemplate/></div>;
  // if (error) return <div>Error: {error.message}</div>;


  return (
    <div style={loginBg}> 
      <div className=" black-filter">
        <Row>
          <Col
            className="col-12 col-sm-3 col-lg-3 offset-md-2 offset-sm-2 offset-lg-2 "
            id="main-form-block"
          >
            <div className="">
              <MainPageHead />
              <div>
                <LoginForm />
              </div>
            </div>
          </Col>
        </Row>
        <div>
          <Footer islogin={false} />
        </div>
      </div>
    </div>
  );
}
